export const SHOW_GLOBAL_LOADER = 'SHOW_GLOBAL_LOADER';

//settings
export const SET_LANGUAGE_LIST = 'SET_LANGUAGE_LIST';
export const SET_TRANSLATIONS = 'SET_TRANSLATIONS';
export const SET_CATALOG_MENU_LOADING = 'SET_CATALOG_MENU_LOADING';
export const SET_CATALOG_MENU = 'SET_CATALOG_MENU';
export const SET_LIST_CATEGORY_FILTERS = 'SET_LIST_CATEGORY_FILTERS';
export const SET_LIST_CATEGORY_FILTERS_LOADING = 'SET_LIST_CATEGORY_FILTERS_LOADING';
export const SET_VARIABLES = 'SET_VARIABLES';
export const CHANGE_LOADING_LIST = 'CHANGE_LOADING_LIST';
export const SET_LIST = 'SET_LIST';
export const SET_TRANSLATION_LOADING = 'SET_TRANSLATION_LOADING'

//category
export const GET_CATEGORY = 'GET_CATEGORY'
export const GET_CATEGORY_LOADING = 'GET_CATEGORY_LOADING'

//order
export const FAST_ORDER = 'FAST_ORDER'
export const THANKS_ORDER = 'THANKS_ORDER'
export const SET_HISTORY_ORDERS = 'SET_HISTORY_ORDERS'
export const SET_CURRENT_ORDER = 'SET_CURRENT_ORDER'
export const ADD_BASKET = 'ADD_BASKET'
export const INCREMENT_BASKET_LIST_COUNT = 'INCREMENT_BASKET_LIST_COUNT'
export const DECREMENT_BASKET_LIST_COUNT = 'DECREMENT_BASKET_LIST_COUNT'
export const REMOVE_ITEM_FROM_BASKET = 'REMOVE_ITEM_FROM_BASKET'
export const RESET_BASKET = 'RESET_BASKET'
export const NOVA_POSHTA_SET_TOWNS = 'NOVA_POSHTA_SET_TOWNS'
export const NOVA_POSHTA_SET_DEPARTMENS = 'NOVA_POSHTA_SET_DEPARTMENS'
export const CHANGE_ADDRESS = 'CHANGE_ADDRESS'
export const SET_ORDERS_METHODS = 'SET_ORDERS_METHODS'
export const SEARCH_RESULT = 'SEARCH_RESULT'
export const CHANGE_SUCCESS_BUY = 'CHANGE_SUCCESS_BUY'
export const SET_ORDER_STATUS = 'SET_ORDER_STATUS'

//auth
export const CHANGE_POPUP_REGISTER = 'CHANGE_POPUP_REGISTER'
export const CHANGE_POPUP_LOGIN = 'CHANGE_POPUP_LOGIN'
export const CHANGE_POPUP_PASSWORD_RECOVERY = 'CHANGE_POPUP_PASSWORD_RECOVERY'
export const CHANGE_POPUP_PASSWORD_EMAIL = 'CHANGE_POPUP_PASSWORD_EMAIL'
export const CHANGE_POPUP_REGISTER_SUCCESS = 'CHANGE_POPUP_REGISTER_SUCCESS'
export const CHANGE_POPUP_USER_EXIT = 'CHANGE_POPUP_USER_EXIT'
export const SET_LOADING_REGISTRATION = 'SET_LOADING_REGISTRATION'
export const SET_TOKEN = 'SET_TOKEN'
export const REMOVE_TOKEN = 'REMOVE_TOKEN'
export const EMAIL_SENT = 'EMAIL_SENT'
export const CHANGE_POPUP_NEW_PASSWORD = 'CHANGE_POPUP_NEW_PASSWORD'
export const CHANGE_POPUP_PASSWORD_SUCCESS = 'CHANGE_POPUP_PASSWORD_SUCCESS'
export const SET_LOADING_RESET_PASSWORD = 'SET_LOADING_RESET_PASSWORD'
export const SET_LOGIN_DATA = 'SET_LOGIN_DATA'
export const SET_RESTORE_PASSWORD = 'SET_RESTORE_PASSWORD'
export const SET_LOADING_RESTORE_PASSWORD = 'SET_LOADING_RESTORE_PASSWORD'
export const DELETE_PRODUCTS = 'DELETE_PRODUCTS'
export const SHOW_CHANGE_PASSWORD_POPUP='SHOW_CHANGE_PASSWORD_POPUP'
export const SET_LOADING_LOGIN='SET_LOADING_LOGIN'


//user-data
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_USER_UPDATED_INFO = 'SET_USER_UPDATED_INFO'

//card
export const SET_PRODUCT_DATA = 'SET_PRODUCT_DATA'
export const SET_PRODUCT_ATTRIBUTES = 'SET_PRODUCT_ATTRIBUTES'
export const SET_POPULAR_PRODUCTS = 'SET_POPULAR_PRODUCTS'

//home
export const SET_LATEST_PRODUCTS = 'SET_LATEST_PRODUCTS'
export const SET_HOME_CONTENT = 'SET_HOME_CONTENT'
export const SET_CONTACTS_CONTENT = 'SET_CONTACTS_CONTENT'
export const SET_MENU_CONTENT = 'SET_MENU_CONTENT'
export const SET_ABOUT_CONTENT = 'SET_ABOUT_CONTENT'
export const SET_NEWS = 'SET_NEWS'
export const SET_CURRENT_NEWS = 'SET_CURRENT_NEWS'
export const MENU_LOADING = 'MENU_LOADING'
export const CONTACTS_LOADING = 'CONTACTS_LOADING'
export const HOME_CONTENT_LOADING = 'HOME_CONTENT_LOADING'
export const LATEST_PRODUCTS_LOADING = 'LATEST_PRODUCTS_LOADING'
export const ARTICLES_LOADING = 'ARTICLES_LOADING'
export const ABOUT_LOADING = 'ABOUT_LOADING'



